module.exports = __webpack_public_path__ + "media/images/ac_templates/201/mnt-e8191bfd33143029878e0bce90828703.jpg";